import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.is-nan.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { spacing } from 'styles/globals';
import Button from 'components/Button';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import { getNumberFieldWidth } from 'components/TextInput/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ButtonDrawer = styled.div.withConfig({
  displayName: "NumberField__ButtonDrawer",
  componentId: "sc-1m2nlp7-0"
})(["display:flex;justify-content:flex-start;gap:", ";margin-top:", ";"], spacing.xs, spacing.xs);
function NumberField(_ref) {
  var id = _ref.id,
    title = _ref.title,
    _ref$initialValue = _ref.initialValue,
    initialValue = _ref$initialValue === void 0 ? 0 : _ref$initialValue,
    min = _ref.min,
    max = _ref.max,
    disabled = _ref.disabled,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(String(initialValue)),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var parsed = parseInt(value);
  var isValid = !Number.isNaN(parsed) && (min === undefined || parsed >= min) && (max === undefined || parsed <= max);
  var isDirty = isValid && parsed !== initialValue;
  function handleSave(e) {
    e.preventDefault();
    if (isValid) {
      onChange === null || onChange === void 0 || onChange(id, parsed, title);
    }
  }
  function handleReset() {
    setValue(String(initialValue));
  }
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSave,
    children: [/*#__PURE__*/_jsx(FormField, {
      id: id,
      label: title,
      children: /*#__PURE__*/_jsx(TextInput, {
        id: id,
        type: "number",
        min: min,
        max: max,
        value: value,
        disabled: disabled,
        onChange: function onChange(e) {
          return setValue(e.target.value);
        },
        style: {
          width: getNumberFieldWidth(Number.isNaN(parsed) ? initialValue : parsed)
        }
      })
    }), isDirty && !disabled && /*#__PURE__*/_jsxs(ButtonDrawer, {
      children: [/*#__PURE__*/_jsx(Button, {
        size: "medium",
        variant: "transparent",
        onClick: handleReset,
        children: t('actions_cancel')
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        icon: "ok",
        size: "medium",
        variant: "primary",
        isDisabled: !isValid,
        children: t('actions_save')
      })]
    })]
  });
}
export default NumberField;